import React, { useEffect } from 'react';
import { Typography, Container, Paper, Button, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import './App.css';

// Shared styling for the 3 category buttons (Commercial Stores / Villas / Tourist).
// Uses theme primary color (slate blue) with white text → stands out clearly.
const categoryButtonSx = {
  width: '100%',
  maxWidth: 190,
  minWidth: 190,
  py: 1,
  px: 2.5,
  fontSize: '0.75rem',
  fontWeight: 'bold',
  letterSpacing: '0.1px',
  whiteSpace: 'nowrap',
  borderRadius: 1, // theme.shape.borderRadius (16) * 0.5 → ~8px
};

const Portfolio = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    const lang = new URLSearchParams(location.search).get('lang');
    if (lang) i18n.changeLanguage(lang);
  }, [location, i18n]);

  return (
    <Container maxWidth="md" sx={{ py: 3 }}>
      {/* .home-paper class provides padding/radius/shadow */}
      <Paper elevation={3} className="home-paper">
        {/* h4 typography from MUI theme */}
        <Typography variant="h4" align="center">
          {t('Port')}
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{ mt: 3, mb: 5 }}
        >
          {t('here')}
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/portfolio/commercialstores"
              sx={categoryButtonSx}
            >
              {t('COMMERCIAL STORES')}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/portfolio/villas"
              sx={categoryButtonSx}
            >
              {t('VILLAS')}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={3} sx={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/portfolio/tourist_accommodations"
              sx={categoryButtonSx}
            >
              {t('TOURIST ACCOMODATIONS')}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default Portfolio;
